import { render, staticRenderFns } from "./Detail-PaymentMadeBills.vue?vue&type=template&id=33ca7a78&scoped=true"
import script from "./Detail-PaymentMadeBills.vue?vue&type=script&lang=js"
export * from "./Detail-PaymentMadeBills.vue?vue&type=script&lang=js"
import style0 from "./Detail-PaymentMadeBills.vue?vue&type=style&index=0&id=33ca7a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca7a78",
  null
  
)

export default component.exports